import { render, staticRenderFns } from "./Thickness.vue?vue&type=template&id=5bb4d075&scoped=true"
import script from "./Thickness.vue?vue&type=script&lang=js"
export * from "./Thickness.vue?vue&type=script&lang=js"
import style0 from "./Thickness.vue?vue&type=style&index=0&id=5bb4d075&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb4d075",
  null
  
)

export default component.exports